import React from 'react'

const StaticsOrderHourTable = (props) => {

    const { loading, error, data } = props
    const TotalsOrder = data.reduce((accumulator, currentValue) => accumulator + currentValue.totalOrders, 0)
    const TotalsItems = data.reduce((accumulator, currentValue) => accumulator + currentValue.totalItems, 0)
    const TotalsItemsLab = data.reduce((accumulator, currentValue) => accumulator + currentValue.totalItemsMCLab, 0)

    return (
        <div className="StaticsTableOrderHour">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className='text-left'>Thời gian</th>
                        <th>Tổng đơn đẩy xưởng</th>
                        <th>Tổng items đẩy xưởng</th>
                        <th>Item MC Lab</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading === null && !!error && error.length > 0 && <tr>
                            <td colSpan={3} className='text-danger'>{error}</td>
                        </tr>
                    }

                    {
                        loading && <tr>
                            <td colSpan={3}>Loading...</td>
                        </tr>
                    }
                    <tr >
                        <td className='text-left'>Total</td>
                        <td>{TotalsOrder || 0}</td>
                        <td>{TotalsItems || 0}</td>
                        <td>{TotalsItemsLab || 0}</td>
                    </tr>
                    {
                        !!data && data.length > 0 && data.map((item, index) =>
                            <tr key={index}>
                                <td className='text-left'>{item.phase_time || ''}</td>
                                <td>{item.totalOrders || 0}</td>
                                <td>{item.totalItems || 0}</td>
                                <td>{item.totalItemsMCLab || 0}</td>
                            </tr>
                        )
                    }

                    {
                        error.length === 0 && !loading && (!!data && data.length === 0) && <tr>
                            <td colSpan={3}>No data</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default StaticsOrderHourTable
